import { render, staticRenderFns } from "./OrderCardList.vue?vue&type=template&id=99cdbdfc&scoped=true"
import script from "./OrderCardList.vue?vue&type=script&lang=js"
export * from "./OrderCardList.vue?vue&type=script&lang=js"
import style0 from "./OrderCardList.vue?vue&type=style&index=0&id=99cdbdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cdbdfc",
  null
  
)

export default component.exports